var _defs, _rect, _animateTransform, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerOrb6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    rx: 6,
    ry: 6,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "orb",
    cx: "75%",
    cy: "25%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--color-primary, #1FE1FF)",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "var(--color-secondary, #8B6CFF)",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--color-secondary, #8B6CFF)",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#clip)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    fill: "url(#orb)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0,0; -4,-4; 0,0",
    dur: "6s",
    repeatCount: "indefinite"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-reduced-motion: reduce) { animateTransform { display:none; } }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerOrb6);
export default __webpack_public_path__ + "static/media/corner-orb-6.107809d111d8bbe6c00a96d1b3c71ea8.svg";
export { ForwardRef as ReactComponent };